export default "__VITE_ASSET__B1txCMs3__"